﻿import { NgModule,enableProdMode} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
/**后者添加 */
import { Camera } from '@ionic-native/camera/ngx';//照相机
import { ImagePicker } from '@ionic-native/image-picker/ngx';//相册获取照片
import { Device } from '@ionic-native/device/ngx';//硬件设备
import {HttpClientModule } from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {BaseModal} from '../model/base';
import { AppConfig} from '../app/app.config';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';//扫描二维码
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';//禁止手机横屏
import { AppUpdate } from '@ionic-native/app-update/ngx';//android更新版本
import { Sim } from '@ionic-native/sim/ngx'; //获取sim卡信息
import { Base64 } from '@ionic-native/base64/ngx';//转换成64位
import { FileTransfer  } from '@ionic-native/file-transfer/ngx';//上传图片
import { HashLocationStrategy,LocationStrategy} from '@angular/common';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { File } from "@ionic-native/file/ngx";
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { FileOpener} from '@ionic-native/file-opener/ngx';

import { SQLite } from '@ionic-native/sqlite/ngx';
import { ImageResizer } from '@ionic-native/image-resizer/ngx'; 
// import { PhotoLibrary } from '@ionic-native/photo-library';
// import { GaoDeLocation } from '@ionic-native/gao-de-location/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import {SimplePdfViewerModule, SimplePdfViewerComponent} from 'simple-pdf-viewer';
// import { KpidetailPageModule } from './swy/kpidetail/kpidetail.module';
// import { VisitInstoreInfoComComponent } from './icebox/visitplatform/visit-instore-info-com/visit-instore-info-com.component';
 
//import { Keychain } from "@ionic-native/keychain/ngx";
enableProdMode();
@NgModule({
  declarations: [AppComponent,
    // VisitInstoreInfoComComponent
  ],
  entryComponents: [
 

  ],
  imports: [BrowserModule, BrowserAnimationsModule,FormsModule,HttpClientModule,IonicModule.forRoot({swipeBackEnabled:false,scrollAssist:true}), AppRoutingModule
  // StockCheckPageModule
  // SimplePdfViewerModule 
    ,
 
  // KpidetailPageModule
  ],
  providers: [
    StatusBar,
    Camera,
    ImagePicker,
    Device,
    SplashScreen,
    BarcodeScanner,
    ScreenOrientation,
    AppUpdate,
    BaseModal,
    AppConfig,
    Geolocation,
    Sim,
    AppVersion,
    Base64,
    FileTransfer,
    InAppBrowser,
    File,
    Keyboard,
    FileOpener,
    SQLite,
    ImageResizer,
    // PhotoLibrary,
    // GaoDeLocation,
      FilePath,
      //Keychain,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
